import { Component, OnInit } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';
import { ShopService } from '../../../configuration/services/shop.service';

@Component({
  selector: 'app-home-inventory',
  templateUrl: './home-inventory.component.html',
  styleUrls: ['./home-inventory.component.css'],
  providers:[InventoryService,ShopService]
})
export class HomeInventoryComponent implements OnInit {

  inventoryInProgress: boolean = false;
  inventoryId: number = null;
  role:number = 3;

  constructor(private inventoryService: InventoryService, private shopService:ShopService) { }

  ngOnInit() {
    this.getInventory();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getInventory(){
    let params = {
      where: {
        end_date: null
      },
      sort: 'number DESC'
    };
    this.inventoryService.query(params)
    .subscribe((inventories) => {
      console.log(inventories);
      if (inventories.length > 0){
        this.inventoryInProgress = true
        this.inventoryId = inventories[0].id;
      }
    });
  }

  createInventory(){
    let body = {
      number:1,
      init_date: new Date(),
    }
    let params = {
      sort: 'number DESC',
      limit:1
    };
    this.inventoryService.query(params)
    .subscribe((inventories) => {
      if (inventories.length == 1){
        body.number = inventories[0].number + 1;
      }
      this.inventoryService.create(body)
      .subscribe((invneotry) => {
        this.getInventory();
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/components/home-inventory/home-inventory.component.ts